function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useCallback, useEffect, useState } from "react";
import { useLayoutEffect } from "../../../hooks/useLayoutEffect";
import { BreakpointsProvider, defaultBreakpoints } from "../BreakpointsProvider/index";
import { processPropertiesForState } from "../utils/breakpointsSize";
var isEventAvailable = function() {
    return typeof window !== 'undefined' && !!window.addEventListener && !!window.removeEventListener;
};
export var Breakpoints = function(param) {
    var s = param.s, m = param.m, l = param.l, xl = param.xl, ssrSize = param.ssrSize, children = param.children;
    var ref = _slicedToArray(useState(_objectSpread({}, defaultBreakpoints, _objectSpread({}, s ? {
        s: Math.floor(s)
    } : undefined, m ? {
        m: Math.floor(m)
    } : undefined, l ? {
        l: Math.floor(l)
    } : undefined, xl ? {
        xl: Math.floor(xl)
    } : undefined, ssrSize ? {
        ssrSize: ssrSize
    } : undefined))), 2), state = ref[0], setState = ref[1];
    useEffect(function() {
        setState(function(previousState) {
            return _objectSpread({}, previousState, processPropertiesForState(_objectSpread({}, previousState, s ? {
                s: Math.floor(s)
            } : undefined, m ? {
                m: Math.floor(m)
            } : undefined, l ? {
                l: Math.floor(l)
            } : undefined, xl ? {
                xl: Math.floor(xl)
            } : undefined, ssrSize ? {
                ssrSize: ssrSize
            } : undefined)));
        });
    }, [
        s,
        m,
        l,
        xl,
        ssrSize
    ]);
    var listenerCallback = useCallback(function() {
        return setState(function(previousState) {
            return _objectSpread({}, previousState, processPropertiesForState(previousState));
        });
    }, [
        setState
    ]);
    useLayoutEffect(function() {
        if (isEventAvailable()) {
            window.addEventListener('resize', listenerCallback);
        }
        if (typeof document !== 'undefined' && document.createEvent && document.dispatchEvent) {
            var event = document.createEvent('HTMLEvents');
            event.initEvent('resize', true, false);
            document.dispatchEvent(event);
        }
        return function() {
            if (isEventAvailable()) {
                window.removeEventListener('resize', listenerCallback);
            }
        };
    }, [
        listenerCallback
    ]);
    return _jsx(BreakpointsProvider, {
        value: state,
        children: children
    });
};
export default Breakpoints;
